module.exports = __webpack_public_path__ + "static/media/readeo-logo-free-model.7eb8b808.svg";